import dynamic from "next/dynamic";
import { memo, useContext } from "react";

import MainFormContext from "context/main-form";

import MainFormSteps from "./steps";

const Result = dynamic(() => import("components/form/result"))
const SendProjectToSanjagh = dynamic(() => import("components/form/send-to-sanjagh"))



function MainForm() {

    const { values } = useContext(MainFormContext)


    return (
        values.cityNotCovered ?
            ( // if city is not covered
                <SendProjectToSanjagh />
            )
            :
            values.step > 3 ?
                <Result />
                :
                <MainFormSteps />
    )
}

export default memo(MainForm)